module.exports = "<svg viewBox=\"0 0 27.7 13.8\"><path d=\"M19.9 0c0 3.3-2.7 6.1-6.1 6.1-3.3 0-6.1-2.7-6.1-6.1H0c0 7.6 6.2 13.8 13.8 13.8 2.2 0 4.2-.5 6.1-1.4 4.6-2.2 7.8-7 7.8-12.4h-7.8z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/circle-half.svg
// module id = 276
// module chunks = 1